import { render, staticRenderFns } from "./Report-page.vue?vue&type=template&id=74230be2&"
import script from "./Report-page.vue?vue&type=script&lang=js&"
export * from "./Report-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports